import { FC, Fragment } from 'react'
import Text from 'antd/es/typography/Text'
import { StrapiDataItem } from '../../../../../../../types/strapi/strapi'
import OrderRequestInterface from '../../../../../../../types/api/order-request'
import { MaterialRequirementsConfiguration } from '../../../../../../../types/api/components/material/material-requirements-configuration'
import MaterialType from '../../../../../../../types/api/material-type'
import Receipt from './receipt'

interface OrderRequestProps {
    config: MaterialRequirementsConfiguration
    materialType: MaterialType
    data: StrapiDataItem<OrderRequestInterface>[]
    shipmentDocId: string
}

const OrderRequest: FC<OrderRequestProps> = ({ data, config, materialType, shipmentDocId }) => {
    const unitShortName = materialType?.unit?.shortName ?? ''
    const amountWithUnit = unitShortName ? `${config.amount} ${unitShortName}` : `${config.amount}`

    if (data.length === 0) {
        return (
            <Text type={'warning'}>
                {config.material?.width} {amountWithUnit} - Заявки на заказ пока не сформированы
            </Text>
        )
    }

    const renderOne = (orderRequest: StrapiDataItem<OrderRequestInterface>) => {
        const width = <Text strong>{config.material?.width}</Text>
        const orderRequestAmountWithUnit = unitShortName
            ? `${orderRequest.amount} ${unitShortName}`
            : `${orderRequest.amount}`

        switch (orderRequest.requestStatus) {
            case 'Новый':
                return (
                    <Text>
                        {width} создана заявка на заказ в кол-ве {orderRequestAmountWithUnit}
                    </Text>
                )
            case 'Отменен':
                return (
                    <Text type={'danger'}>
                        {width} отменена заявка на заказ в кол-ве {orderRequestAmountWithUnit}
                    </Text>
                )
            case 'Обработан':
                return (
                    <Receipt
                        config={config}
                        shipmentDocId={shipmentDocId}
                        materialType={materialType}
                        orderRequestDocumentId={orderRequest.documentId}
                    />
                )
            default:
                return null
        }
    }

    return (
        <>
            {data.map(orderRequest => (
                <Fragment key={orderRequest.documentId}>{renderOne(orderRequest)}</Fragment>
            ))}
        </>
    )
}

export default OrderRequest
